'use client';

import type { LangType, schema } from 'database';
import { useStore } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';
import {
  allCssAtom,
  allCssVariablesAtom,
  allJsAtom,
  brandColorAtom,
  copyrightAtom,
  defaultAuthorAtom,
  faviconAtom,
  fontAtom,
  fontSizeAtom,
  footerLinksAtom,
  headerActionsAtom,
  headerLinksAtom,
  langAtom,
  logoAtom,
  quotionBadgeUrlAtom,
  showQuotionBadgeAtom,
  themeAtom,
} from './design-state';

export type HydrateAllAtoms = {
  logo: string;
  favicon: string;
  headerLinks: schema.BlogLink[];
  headerActions?: schema.HeaderActions | null;
  footerLinks: schema.BlogLink[];
  copyright: string;
  showQuotionBadge?: boolean;
  quotionBadgeUrl?: string | null;
  lang?: LangType;

  theme?: schema.ThemeType | null;
  font?: string | null;
  fontSize?: number | null;
  brandColor?: string | null;
  defaultAuthor?: schema.DefaultAuthor | null;
  cssVariables?: schema.AllCssVariables | null;
  customCss?: string | null;
  customJs?: string | null;
};

export function HydrateAllAtoms(props: HydrateAllAtoms) {
  const store = useStore();
  // Initialize optional values too: later RSC refreshes must not hydrate
  // newly populated fields while design controls are already subscribed.
  useHydrateAtoms(
    [
      [logoAtom, props.logo],
      [faviconAtom, props.favicon],
      [headerLinksAtom, props.headerLinks],
      [headerActionsAtom, props.headerActions ?? headerActionsAtom.init],
      [footerLinksAtom, props.footerLinks],
      [copyrightAtom, props.copyright],
      [
        showQuotionBadgeAtom,
        props.showQuotionBadge ?? showQuotionBadgeAtom.init,
      ],
      [quotionBadgeUrlAtom, props.quotionBadgeUrl ?? quotionBadgeUrlAtom.init],
      [defaultAuthorAtom, props.defaultAuthor ?? defaultAuthorAtom.init],
      [langAtom, props.lang ?? langAtom.init],
      [themeAtom, props.theme ?? themeAtom.init],
      [fontAtom, props.font ?? fontAtom.init],
      [fontSizeAtom, props.fontSize ?? fontSizeAtom.init],
      [brandColorAtom, props.brandColor ?? brandColorAtom.init],
      [allCssVariablesAtom, props.cssVariables ?? allCssVariablesAtom.init],
      [allCssAtom, props.customCss ?? allCssAtom.init],
      [allJsAtom, props.customJs ?? allJsAtom.init],
    ] as const,
    { store },
  );

  return <></>;
}
